<template>
  <div class="box">
    <div class="floor1">
      <div class="content">
        <img src="../../assets/img/introduction/yh.svg" alt="" class="yh" />
        <img
          src="../../assets/img/introduction/m2.svg"
          alt=""
          class="descroption"
        />
        <div class="title">Repayment guide</div>
      </div>
    </div>
    <div class="step_box">
      <div class="title1 title_line">Step 1</div>
      <div class="title2">Know what day your Installment date</div>
      <img
        src="../../assets/img/introduction/step1.png"
        alt=""
        class="step1_img"
      />
      <div class="step_txt_box">
        <div class="step_txt">Go to ME page and click the loan button</div>
        <div class="step_txt">Check the repayment date</div>
      </div>
      <div class="step_content">
        {{
          IsTest
            ? "Your full loan repayment period:91-180 days,and your loan will be repaid in monthly installments."
            : "Your repayment date is every 7 days after the loan issuance date."
        }}
        The corresponding repayment is paid before the repayment date.
        {{
          IsTest
            ? ""
            : `For example,
        if your loan issuance date is January 1, your first repayment date is
        January 7, and your second repayment date is January 14.`
        }}
        <br />
        Tips: You can find your loan issuance date and the repayment date of
        each instalment during the loan period in the "Personal Loan Repayment
        Schedule" in the app after loan issuance.
      </div>
    </div>
    <div class="step_box">
      <div class="title1 title_line">Step 2</div>
      <div class="title2">Find out how much you repay each installment</div>
      <img
        src="../../assets/img/introduction/step2.png"
        alt=""
        class="step2_img"
      />
      <div class="step_txt_box">
        <div class="step_txt">Check the Loan details page</div>
      </div>
      <div class="step_content">
        The repayment method of this loan is to repay the principal and interest
        on a {{ IsTest ? "monthly" : "weekly" }} basis (except for the first
        installment).<br /><br />
        After the loan is issued, the "Personal Loan Repayment Schedule" lists
        the loan principal and interest that you should repay each instalment
        during the loan period for your reference.
      </div>
    </div>
    <div class="step_box">
      <div class="title1 title_line">Step 3</div>
      <div class="title2">Know your repayment account</div>
      <img
        src="../../assets/img/introduction/step3.png"
        alt=""
        class="step3_img"
      />
      <div class="step_txt_box">
        <div class="step_txt">M-PESA account</div>
      </div>
      <div class="step_content">
        Repayment accounts are wallet accounts and group current deposit
        accounts.<br /><br />
        The repayment account is a personal bank account that you open at
        Kinvest (or free of charge after the loan is approved according to your
        authorization) and authorize our bank to deduct your corresponding
        installment amount from it on time.
      </div>
    </div>
    <div class="step_box">
      <div class="title1 title_line">Step 4</div>
      <div class="title2">
        Deposit the current installment into your repayment account before each
        installment date
      </div>
      <img
        src="../../assets/img/introduction/step4.png"
        alt=""
        class="step1_img"
      />
      <div class="step_txt_box">
        <div class="step_txt">Click the Deposit button on the Current page</div>
        <div class="step_txt">Enter deposit amount</div>
      </div>
      <div class="step_content">
        You can take the initiative to repay, or you can ensure that the balance
        on the current account and the group account is sufficient, and we will
        automatically deduct the payment on the due date.
      </div>
    </div>
    <div class="footer_content">
      If you have any questions or inquiries about personal loan repayment
      procedures, Please contact our customer service email
      <a href="mailto:kinvest.help@gmail.com">kinvest.help@gmail.com</a> for
      responses.
    </div>
    <div class="el-loading-mask" v-if="!hasToken">
      You are not logged in. Please log in to view the page
    </div>
  </div>
</template>
<script>
import axios from "@/http/axios";
export default {
  data() {
    return {
      IsTest: true,
      hasToken: false,
    };
  },
  created() {
    let o = this.$route.query;
    if (o.token) {
      this.hasToken = true;
    } else {
      this.hasToken = false;
      return false;
    }
    sessionStorage.setItem("token", o.token);
    axios.post("/api/appgateway/user/getUserInfo", {}).then((res) => {
      if (res.code == "00000") {
        this.IsTest = res.data.userType == "99";
      }
    });
  },
};
</script>
<style lang="scss" scoped>
@import url("../../assets/css/index.css");
.title_line {
  position: relative;
  &::before {
    content: " ";
    width: 38px;
    height: 10px;
    position: absolute;
    background: #ffe0c1;
    left: 16px;
    top: 12px;
    z-index: -1;
  }
}
.box {
  margin: 0 auto;
  width: 100%;
  max-width: 600px;
  background-color: #f9f9f9;
  padding-top: 96px;
  padding-bottom: 20px;
  position: relative;
  .floor1 {
    width: 100%;
    height: 300px;
    background: linear-gradient(
      180deg,
      #fff3e6 0%,
      rgba(255, 247, 238, 0) 100%
    );
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    .content {
      width: 100%;
      position: relative;
      .yh {
        position: absolute;
        left: 16px;
        top: 20px;
        z-index: 1;
        height: 40px;
      }
      .descroption {
        position: absolute;
        top: 0;
        right: 16px;
        width: 109px;
      }
      .title {
        position: absolute;
        left: 16px;
        top: 44px;
        font-size: 24px;
        font-family: "rb";
        font-weight: bold;
        color: #333333;
        line-height: 28px;
        z-index: 2;
      }
    }
  }
  .step_box {
    margin: 0 16px 16px;
    padding: 24px 0;
    background: #ffffff;
    border-radius: 2px;
    position: relative;
    z-index: 200;
    .title1 {
      font-size: 16px;
      font-family: "rb";
      font-weight: bold;
      color: #303f49;
      line-height: 19px;
      padding: 0 16px;
    }
    .title2 {
      padding: 10px 16px 24px;
      font-size: 16px;
      font-family: "rm";
      font-weight: 500;
      color: #303f49;
      line-height: 19px;
    }
    .step1_img {
      width: 100%;
      display: block;
    }
    .step2_img {
      width: 67%;
      display: block;
      margin: 0 auto;
    }
    .step3_img {
      width: 67%;
      display: block;
      margin: 0 auto;
      padding-bottom: 14px;
    }
    .step_txt_box {
      display: flex;
      padding: 0 16px 20px;
      .step_txt {
        flex: 1;
        text-align: center;
        font-size: 12px;
        font-family: "rr";
        font-weight: 400;
        color: #979fa4;
        line-height: 20px;
      }
    }
    .step_content {
      font-size: 12px;
      font-family: "rr";
      font-weight: 400;
      color: #50616c;
      line-height: 21px;
      padding: 0 16px;
    }
  }
  .footer_content {
    margin: 0 16px;
    font-size: 12px;
    font-family: "rr";
    font-weight: 400;
    color: #50616c;
    line-height: 21px;
    a {
      text-decoration: none;
      font-size: 12px;
      font-family: "rr";
      font-weight: 400;
      color: #009cff;
      line-height: 21px;
    }
  }
}
</style>
